import { render, staticRenderFns } from "./DocumentsToLink.vue?vue&type=template&id=d5405608"
import script from "./DocumentsToLink.vue?vue&type=script&lang=js"
export * from "./DocumentsToLink.vue?vue&type=script&lang=js"
import style0 from "./DocumentsToLink.vue?vue&type=style&index=0&id=d5405608&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports